import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const SimpleTable = ({ tableItems }) => {
  return (
    <VisibleLoading>
      {({ ref, className }) => (
        <div
          ref={ref}
          className={`mx-auto mt-6 mb-6 w-[calc(90vw-16)] xl:w-(--container-width) xl:px-0 ${className || ''}`.trim()}
        >
          <div className="mt-12 flex flex-wrap items-stretch lg:mx-0 lg:justify-center lg:overflow-x-visible lg:overflow-y-visible lg:px-0 lg:py-0 xl:flex-wrap">
            {(tableItems || []).map((item) => (
              <SimpleTableItem key={item.id} {...item} />
            ))}
          </div>
        </div>
      )}
    </VisibleLoading>
  );
};
export default SimpleTable;

const SimpleTableItem = ({ title, value, icon }) => {
  return (
    <div className="border-black-20 basis-full border-b-1 p-4 last:border-b-0 xl:basis-1/4 xl:border-r-1 xl:border-b-0 xl:p-6 xl:first:border-l-1 xl:last:border-r-1">
      <div
        className={`mb-6 flex h-[48px] w-[48px] items-center justify-center rounded-full border border-black text-black xl:mb-12`}
      >
        <Icon type={icon} width={24} height={24} />
      </div>

      <div className="txt-md mb-2">{title}</div>
      <div className="heading-5">{value}</div>
    </div>
  );
};
